import React from 'react';
import Language from '../Language.data';

function PaintsAndCoatings(props) {
    return (
        <>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col">
                    <h3>{Language[props.currentLanguage].industries.paintsAndCoatings.surfaceCoatings}</h3>
                </div>
            </div>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col">
                    {Language[props.currentLanguage].applications}:
                </div>
            </div>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col">
                    {Language[props.currentLanguage].industries.paintsAndCoatings.applicationsText}
                </div>
            </div>
            <div className="row mt-3 d-flex justify-content-center align-items-center">
                <div className="col">
                    {Language[props.currentLanguage].industries.paintsAndCoatings.industryText}
                </div>
            </div>
            <div className="row d-flex justify-content-center align-items-center">
                <div className="col">
                    <ul>
                        <li>{Language[props.currentLanguage].functionalities.barrierProperties}</li>
                        <li>{Language[props.currentLanguage].functionalities.coloursAndEffects}</li>
                        <li>{Language[props.currentLanguage].functionalities.increasedVisibility}</li>
                        <li>{Language[props.currentLanguage].functionalities.irReflective}</li>
                        <li>{Language[props.currentLanguage].functionalities.antiCorrosion}</li>
                        <li>{Language[props.currentLanguage].functionalities.electricalAndThermalConductivity}</li>
                        <li>{Language[props.currentLanguage].functionalities.renewableRawMaterials}</li>
                        <li>{Language[props.currentLanguage].functionalities.defoaming}</li>
                        <li>{Language[props.currentLanguage].functionalities.wettingAndDispersing}</li>
                        <li>{Language[props.currentLanguage].functionalities.levellingAndSlip}</li>
                        <li>{Language[props.currentLanguage].functionalities.viscosityModification}</li>
                    </ul>
                </div>
                <div className="col">
                    <ul>                            
                        <li>{Language[props.currentLanguage].functionalities.adhesion}</li>
                        <li>{Language[props.currentLanguage].functionalities.lightProtection}</li>
                        <li>{Language[props.currentLanguage].functionalities.longerLifetime}</li>
                        <li>{Language[props.currentLanguage].functionalities.thermalInsulation}</li>
                        <li>{Language[props.currentLanguage].functionalities.ageingStability}</li>
                        <li>{Language[props.currentLanguage].functionalities.mattingEffects}</li>
                        <li>{Language[props.currentLanguage].functionalities.lightReflectance}</li>
                        <li>{Language[props.currentLanguage].functionalities.circularity}</li>
                        <li>{Language[props.currentLanguage].functionalities.flameRetardancy}</li>
                        <li>{Language[props.currentLanguage].functionalities.tribology}</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default PaintsAndCoatings;